<div class="main-wrap" >
    <app-sidebar class="sidebarview"></app-sidebar>
    <section class="section" >
        <app-contract-transactions></app-contract-transactions>
        <app-nfts-listing [isMyWallet]="true"></app-nfts-listing>
    </section>
</div>